<template>
  <!-- eslint-disable vue/first-attribute-linebreak, vue/max-attributes-per-line -->
  <div class="distribution-consent-policy">
    <div class="distribution-consent-policy__header">
      <div class="distribution-consent-policy__title">
        Согласие на обработку персональных данных, разрешенных субъектом персональных
        данных для распространения (для Специалистов)
      </div>
      <div class="distribution-consent-policy__date">
        Дата публикации:
        <time class="distribution-consent-policy__date-value">01.09.2026</time>
      </div>
    </div>
    <ul class="distribution-consent-policy__list">
      <li class="distribution-consent-policy__item">
        <div class="distribution-consent-policy__item-text">
          <p class="distribution-consent-policy__item-paragraph">
            Настоящим я, действуя свободно, своей волей и в своем интересе, в соответствии
            со статьей 10.1 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных
            данных», даю согласие Обществу с ограниченной ответственностью «ЛИГАЛ АДС ТЕХ»
            (ОГРН 1227700103245, ИНН 9709078420, далее — Оператор) на распространение
            (предоставление неограниченному кругу лиц) моих персональных данных,
            обрабатываемых Оператором, с целью размещения моего Профиля (Карточки
            Специалиста) и опубликованных мной материалов на сервисе «Юрик.ру», а также
            продвижения сервиса и моих услуг.
          </p>
        </div>
      </li>
      <li class="distribution-consent-policy__item">
        <div class="distribution-consent-policy__item-title">
          1. Категории и перечень персональных данных, разрешенных к распространению
        </div>
        <div class="distribution-consent-policy__item-text">
          <p class="distribution-consent-policy__item-paragraph">
            1.1. Фамилия, имя, отчество;
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.2. Профессиональный статус (Юрист / Адвокат, реестровый номер адвоката — при
            наличии) и сведения о профессиональном опыте (стаж, места работы,
            образование);
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.3. Фотографии, размещенные мной в Профиле;
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.4. Специализации и перечень вопросов, по которым я оказываю услуги;
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.5. Город, ближайшая станция метро и адрес места приема (офиса);
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.6. Расписание приёма (доступные для записи дни и время);
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.7. Стоимость моих услуг, указанная мной в Профиле;
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.8. Рейтинг и отзывы Заказчиков о моей работе;
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            1.9. Материалы, размещенные мной в Профиле (публикации, сведения о судебной
            практике, галерея), а также статьи и иные материалы, опубликованные мной в
            журнале (блоге) сервиса «Юрик.ру», включая указание моего авторства.
          </p>
        </div>
      </li>
      <li class="distribution-consent-policy__item">
        <div class="distribution-consent-policy__item-title">
          2. Ресурсы, на которых осуществляется распространение
        </div>
        <div class="distribution-consent-policy__item-text">
          <p class="distribution-consent-policy__item-paragraph">
            2.1. Сайт
            <a
              class="distribution-consent-policy__item-link"
              href="https://jurik.ru"
              target="_blank"
              rel="noopener noreferrer"
              >https://jurik.ru</a
            >
            и его поддомены.
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            2.2. Рекламные и информационные материалы сервиса «Юрик.ру», размещаемые
            Оператором и его партнёрами в сети Интернет, в средствах массовой информации,
            социальных сетях и иных информационных ресурсах в целях продвижения сервиса и
            услуг Специалистов.
          </p>
        </div>
      </li>
      <li class="distribution-consent-policy__item">
        <div class="distribution-consent-policy__item-title">3. Условия и запреты</div>
        <div class="distribution-consent-policy__item-text">
          <p class="distribution-consent-policy__item-paragraph">
            3.1. Я не устанавливаю запретов и условий на обработку указанных в разделе 1
            персональных данных неограниченным кругом лиц, за исключением следующего:
            запрещается использование данных в целях, не связанных с выбором Специалиста и
            получением юридических услуг, в том числе для массовых рассылок без моего
            согласия.
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            3.2. Персональные данные, не указанные в разделе 1 (в том числе паспортные
            данные, ИНН, платежные данные, номер телефона, адрес электронной почты), к
            распространению не разрешаются.
          </p>
        </div>
      </li>
      <li class="distribution-consent-policy__item">
        <div class="distribution-consent-policy__item-title">
          4. Срок действия и отзыв согласия
        </div>
        <div class="distribution-consent-policy__item-text">
          <p class="distribution-consent-policy__item-paragraph">
            4.1. В отношении данных, указанных в пп. 1.1–1.8, согласие действует в течение
            срока размещения моего Профиля на сервисе «Юрик.ру» либо до отзыва согласия. В
            отношении статей и иных материалов, опубликованных мной в журнале (блоге)
            сервиса (п. 1.9), согласие действует до его отзыва независимо от размещения
            Профиля.
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            4.2. Согласие может быть отозвано в любой момент путем направления требования
            Оператору по электронной почте
            <a class="distribution-consent-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >
            либо почтой по юридическому адресу Оператора. В случае отзыва Оператор
            прекращает распространение персональных данных (публикацию Профиля, указание
            моих данных в материалах) в срок, установленный законодательством.
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            4.3. Я уведомлен(а), что отзыв настоящего согласия не прекращает действие
            предоставленной Оператору лицензии на использование опубликованных мной
            материалов: в этом случае Оператор вправе продолжить их использование без
            указания моих персональных данных (в обезличенном виде).
          </p>
          <p class="distribution-consent-policy__item-paragraph">
            4.4. Я уведомлен(а), что вправе установить дополнительные условия и запреты на
            обработку разрешенных к распространению персональных данных, направив
            соответствующее требование Оператору.
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.distribution-consent-policy {
  .flex-column(@size-x10);

  &__header {
    .flex-column(@size-x3);
  }

  &__title {
    .h-offset-reset();

    font-size: @size-x8;
    font-weight: 700;
    line-height: 130%;
  }

  &__date {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    color: @color-dove-gray;
  }

  &__list {
    .flex-column(@size-x10);

    max-width: 997px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__item-title {
    .h-offset-reset();

    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
  }

  &__item-text {
    .flex-column(@size-x4);
  }

  &__item-paragraph {
    .p-offset-reset();

    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
  }

  &__item-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
